import { chunk } from 'lodash';
import queryString from 'query-string';
import { from, Observable } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { bufferCount, last, mergeAll, mergeMap, pluck, scan } from 'rxjs/operators';

interface Statistics {
    viewCount: string;
    commentCount: string;
    dislikeCount: string;
    favoriteCount: string;
    likeCount: string;
}

interface Video {
    id: string;
    statistics: Statistics;
}

const getYoutubeUrl = function(ids: string[]) {
    const query = queryString.stringify({
        part: 'statistics',
        key: 'AIzaSyBCjv9EKY_xogc51cnuMd1efjo3eLvPGDU',
        id: ids.join(','),
    }, {});
    return `https://www.googleapis.com/youtube/v3/videos?${query}`;
};

export const getVideo$ = (ids: string[]): Observable<Video> => {
    //have to split to multiple requests, query param can't handle too many
    const chunks = chunk(ids, 50);
    return from(chunks).pipe(
        mergeMap(idsChunk => ajax.getJSON(getYoutubeUrl(idsChunk))),
        pluck('items'),
        mergeAll(),
    );
};

export const getViewCount$ = (videoIds: string[]): Observable<number> => getVideo$(videoIds).pipe(
    pluck('statistics', 'viewCount'),
    scan((acc, value: string) => acc + parseInt(value), 0),
    last(),
    bufferCount(videoIds.length),
    mergeAll(),
);

export const youtubeLinkParser = url => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : null;
};
